import axios from 'axios'
import {
  GET_INVITES_FAIL,
  GET_INVITES_REQUEST,
  GET_INVITES_SUCCESS,
} from '../constants/inviteConstants'

export const getInvites = (page) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_INVITES_REQUEST,
    })

    const {
      adminLogin: { adminInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminInfo.token}`,
      },
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invites?page=${page}`,
      config
    )

    dispatch({
      type: GET_INVITES_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_INVITES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
